// extracted by css-extract-rspack-plugin
export default {"title":"PreviewModal__title--fkbQX","header":"PreviewModal__header--XasT8","tools":"PreviewModal__tools--lnpPH"};